// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "EditLink-module--cds--assistive-text--36da9";
export var cdsHideFeedback = "EditLink-module--cds--hide-feedback--fb2df";
export var cdsShowFeedback = "EditLink-module--cds--show-feedback--e6702";
export var cdsSkeleton = "EditLink-module--cds--skeleton--ed05b";
export var cdsVisuallyHidden = "EditLink-module--cds--visually-hidden--cf189";
export var link = "EditLink-module--link--b2ed3";
export var row = "EditLink-module--row--d7aa5";